import { render, staticRenderFns } from "./c-botton-fixed.vue?vue&type=template&id=8e80389c&scoped=true&"
import script from "./c-botton-fixed.vue?vue&type=script&lang=js&"
export * from "./c-botton-fixed.vue?vue&type=script&lang=js&"
import style0 from "./c-botton-fixed.vue?vue&type=style&index=0&id=8e80389c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e80389c",
  null
  
)

export default component.exports